import React, { useState } from 'react'
import './FAQPage.css'
import Header from '../components/Header'
import { GoPlus } from "react-icons/go";
import { Link } from 'react-router-dom';

function FAQPage() {
  const [openSections, setOpenSections] = useState({})

  const toggleSection = (sectionId) => {
    setOpenSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }))
  }

  const faqData = [
    {
      id: 'beginners',
      title: 'Voor Beginners',
      questions: [
        {
          id: 'start-without-experience',
          question: 'Kan ik beginnen met paaldansen zonder ervaring?',
          answer: 'Absoluut, onze lessen zijn geschikt voor zowel beginners als gevorderden. We bieden verschillende niveaus aan zodat iedereen op hun eigen tempo kan leren.'
        },
        {
          id: 'which-course',
          question: 'Welke lessenreeks moet ik kiezen?',
          answer: 'Is paaldansen nieuw voor jou, of wil je jouw basis heropfrissen? Dan schrijf je in voor de Pole Intro lessenreeks. Heb je reeds de Pole Intro lessenreeks (+- 10 lesweken) gevolgd of heb je gelijkaardige ervaring, dan kan je overstappen naar het volgende niveau: Pole Technique 1. Beheers je de vereiste basis van Pole Technique 1, dan kan je overstappen naar Pole Technique 2, enzovoort.'
        },
        {
          id: 'what-to-expect',
          question: 'Wat kan ik verwachten van een paaldansles?',
          answer: 'Onze paaldanslessen duren 90 minuten. Elke les start met een zorgvuldige opwarming. De opwarming is super belangrijk om jouw spieren voor te bereiden op de technieken die we zullen oefenen aan de paal. Kom dus altijd ruim op tijd, zodat je zeker geen deel van de opwarming mist. Vervolgens starten we met technieken aan de paal. Dit kunnen technieken zijn op kracht, maar ook verschillende spins of combinaties van oefeningen. Aan het einde van de les voorzien wij een "freestyle" momentje. Hierbij krijg je tijd om jouw progressie te filmen, leuke foto\'s te maken en er gewoon een moment voor jezelf van te maken. We sluiten af met een cooldown.'
        },
        {
          id: 'trial-lesson',
          question: 'Kan ik een proefles volgen?',
          answer: 'Zeker weten! Wij voorzien 4 reeksen, verspreid over het jaar. Dit volgens het ritme van de seizoenen (Winterreeks, Lentereeks, Zomerreeks, Herfstreeks). Tussen 2 reeksen voorzien we telkens een pauze/vakantie-week. Tijdens deze pauze voorzien wij dan ook proeflessen zodat nieuwe leerlingen een voorproefje kunnen krijgen van hoe paaldansen bij Pole District 85 voelt! Lukt het niet om tijdens deze proeflesweken te komen? Geen zorgen! Met een proeflescredit kun je elk moment inschrijven in één van onze lessen. Hou er wel rekening mee dat je mogelijks midden in een lopende lessenreeks instapt.'
        },
        {
          id: 'join-midway',
          question: 'Ik heb een deel van de reeks gemist, kan ik nog instappen?',
          answer: 'Afhankelijk van het aantal lessen die je gemist hebt en eventuele achtergrond in paaldansen, kan het mogelijk zijn om midden in een reeks in te stappen. We raden aan om eerst contact op te nemen met de instructeur om af te stemmen wat de beste keuze zou zijn.'
        }
      ]
    },
    {
      id: 'registration',
      title: 'Inschrijvingen & Annulaties',
      questions: [
        {
          id: 'pre-registration',
          question: 'Moet ik mij vooraf inschrijven?',
          answer: 'Ja, het wordt sterk aangeraden om je vooraf in te schrijven voor een les. Zo ben je zeker van je plek! Een les gaat door vanaf minimum 4 inschrijvingen. Indien er minder dan 4 leerlingen ingeschreven zijn, heeft Pole District 85 het recht de les te annuleren. Indien Pole District 85 de les annuleert, krijgen de ingeschreven leerlingen uiteraard hun credit terug.'
        },
        {
          id: 'how-to-register',
          question: 'Hoe kan ik me inschrijven voor een les?',
          answer: <>Je kunt éénvoudig inschrijven via ons boekingssyteem. Ons boekingssysteem toont de beschikbare lessen en laat je toe een les te reserveren. Om een les te reserveren zul je credits nodig hebben, zo kun je zelf flexibel jouw lessen inplannen. Meer info over de verschillende credit-pakketten vind je <Link to="/prices">hier</Link></>
        },
        {
          id: 'cancellation',
          question: 'Ik kan niet naar de les komen, wat nu?',
          answer: 'We begrijpen dat er soms onvoorziene omstandigheden zijn. Tot 24 uur voor aanvang van de les, kan je kostenloos annuleren. Bij latere afzeggingen kunnen we helaas geen restitutie aanbieden. We willen graag iedereen gelijk behandelen, dus we kunnen hier geen uitzonderingen op maken.'
        },
        {
          id: 'book-for-friend',
          question: 'Kan ik ook voor een vriend of vriendin boeken?',
          answer: 'Neen, credits zijn strikt persoonlijk en kunnen niet doorgegeven worden.'
        }
      ]
    },
    {
      id: 'lesson-types',
      title: 'Lesvormen & Inhoud',
      questions: [
        {
          id: 'flow-exotic-technique',
          question: 'Wat is het verschil tussen flow, exotic en technique?',
          answer: 'Technique: Dit is van toepassing voor de intro-reeks en de "Pole Technique"-reeksen. De focus ligt hier op "techniek". Hier werk je aan figuren, spins en/of combinaties die passen binnen het niveau van de reeks die je volgt.\n\nFlow: Bij een flow-les, ligt de focus op het choreo-element. Je leert een choreo dansen met elegante en naadloze overgangen zodanig dat jouw dans flowt van begin tot einde. Flow wordt doorgaans op kousen gedanst, maar Pleasers zijn zeker ook mogelijk. Een choreo wordt aangeleerd over 3 lessen (= 3 weken).\n\nExotic: Idem zoals bij Flow, ligt de focus op het choreo-element. Hier leer je een choreo dansen op danscchoenen met hoge hak (welbekend als Pleasers). Exotic wordt doorgaans met deze dansschoenen gedanst, maar kan ook op kousen gedanst worden.'
        },
        {
          id: 'strength-flexibility',
          question: 'Ik wil graag werken aan mijn kracht en/of lenigheid, kan dit?',
          answer: 'Absoluut. Onze "Bootcamp & Flex"-les focust op spierversterking en lenigheidsoefeningen.'
        }
      ]
    },
    {
      id: 'practical',
      title: 'Praktische Informatie',
      questions: [
        {
          id: 'language',
          question: 'In welke taal worden de lessen gegeven?',
          answer: 'Standaard in het Nederlands. Indien nodig, wordt de les in het Engels gegeven.'
        },
        {
          id: 'clothing',
          question: 'Welke kledij draag ik in de les?',
          answer: 'We raden aan om op blote voeten of kousen te komen en een korte short en een top te dragen. Hierdoor heb je voldoende grip op de paal. Vermijd te loszittende kledij, dit is niet altijd even handig.'
        },
        {
          id: 'facilities',
          question: 'Hebben jullie kleedkamers en douches?',
          answer: 'Er is een kleedkamer en toilet aanwezig, maar geen douche.'
        },
        {
          id: 'group-size',
          question: 'Hoeveel mensen zitten er in een groepsles?',
          answer: 'Onze groepslessen hebben een maximum van 14 personen. Dit betekent dat je met 2 personen een paal deelt. Het delen van de paal zorgt ervoor dat je even op adem kan komen, maar stimuleert ook groepsgevoel.'
        },
        {
          id: 'minimum-age',
          question: 'Is er een minimumleeftijd om les bij jullie te volgen?',
          answer: 'Onze lessen zijn gericht op volwassenen, maar jongvolwassenen kunnen deelnemen. Er zijn voorlopig geen kinderlessen.'
        }
      ]
    }
  ]

  return (
    <div className="page_container" id="faq-page">
      <section className="page_section" id="hero-section">
        <Header />
        <div className="sub_section title_section">
          <h1>Veelgestelde Vragen</h1>
        </div>
        <div className="sub_section faq_content">
          <div className="faq_container">
            {faqData.map((section) => (
              <div key={section.id} className="faq_section">
                <h2 className="section_title">{section.title}</h2>
                <div className="questions_container">
                  {section.questions.map((item) => (
                    <div key={item.id} className="faq_item">
                      <div 
                        className="faq_question"
                        onClick={() => toggleSection(item.id)}
                      >
                        <h3>{item.question}</h3>
                        <GoPlus 
                          className={`faq_icon ${openSections[item.id] ? 'open' : ''}`}
                        />
                      </div>
                      <div className={`faq_answer ${openSections[item.id] ? 'open' : ''}`}>
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default FAQPage 